import React from 'react';
import style from './RichMessage.module.less';
export default function RichMessage(_a) {
    var message = _a.message, _b = _a.showIcon, showIcon = _b === void 0 ? true : _b;
    return (React.createElement("span", { className: [
            style['rich-message'],
            showIcon ? '' : style['rich-message-no-icon']
        ].join(' '), dangerouslySetInnerHTML: { __html: message } }));
}
